<script>
import { mapActions } from 'vuex'
import amountMask from '@lib/utils/amount-mask'
import ValidationMixin from '@lib/mixins/validation'

export default {
  name: 'ClaimTopUpAmount',
  mixins: [ValidationMixin],
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      progress: false,
      form: {},
      showErrorMessage: false,
      rules: {
        amount: {
          required: true,
          message: 'This field is required',
        },
      },
    }
  },
  computed: {
    total() {
      return parseFloat(this.claim.amount) + parseFloat(this.form.amount || 0)
    },
  },
  methods: {
    ...mapActions('claims', [
      'claimTopUps',
    ]),
    amountMask,
    onChange(field, value) {
      this.form[field] = value
      delete this.backendErrors[field]
      this.$refs.form.validateField(field)
    },
    onCancel() {
      this.$emit('cancel')
    },
    async onSubmit() {
      this.clearBackendErrors()
      const formValid = await this.$refs.form.validate().catch(() => false)
      if (!formValid) return

      this.progress = true

      const amount = parseFloat(this.form.amount)

      const [error, result] = await this.claimTopUps({
        id: this.claim.id,
        amount,
      })

      if (!error) {
        this.$emit('update', result)
      } else {
        this.processBackendErrors(error)
        const { detail } = error
        if (detail === 'Access Denied.') {
          this.showErrorMessage = true
        }
      }

      this.progress = false
    },
  },
}
</script>

<template>
  <data-box
    header="Top up amount"
    :status="null"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="left"
      class="card-form"
    >
      <el-form-item
        label="Claim No."
        required
        :class="$style.formItem"
      >
        <el-input
          :value="claim.number"
          disabled
        />
      </el-form-item>
      <el-form-item
        label="Claim Settlement Amount"
        required
        :class="$style.formItem"
      >
        <el-input
          :value="claim.amount"
          disabled
        >
          <template #prepend>
            $
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="New Top Up Amount"
        prop="amount"
        :error="backendErrors.amount"
        :class="$style.formItem"
      >
        <el-input
          v-model="form.amount"
          @input="onChange('amount', amountMask($event))"
        >
          <template #prepend>
            $
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <data-list :class="$style.total">
      <dt>Total</dt>
      <dd>{{ total | dollar }}</dd>
    </data-list>
    <div>
      <el-button
        type="primary"
        plain
        :class="$style.button"
        @click="onCancel"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :class="$style.button"
        :loading="progress"
        @click="onSubmit"
      >
        Save
      </el-button>
    </div>
    <div
      v-if="showErrorMessage"
      :class="$style.errorMessage"
    >
      This record cannot be saved. This claim may exceed the value you are authorised to settle or edit.
    </div>
  </data-box>
</template>

<style lang="scss" module>
.formItem {
  label {
    margin-top: rem(8px);
  }
}

.formText {
  margin: rem(30px 0 20px);
}

.button {
  padding-right: rem(50px);
  padding-left: rem(50px);
}

.total {
  margin-bottom: rem(20px);
}

.errorMessage {
  margin-top: 1rem;
  color: var(--color-error);
}
</style>
